import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram, Linkedin, Facebook, Youtube, ArrowUpRight } from 'lucide-react';
import { contactInfo, navigation } from '../data/mock';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="relative bg-[#050F2E] text-white overflow-hidden">
      {/* Decorative brand blobs */}
      <div className="absolute -top-32 -right-32 h-96 w-96 rounded-full bg-[#FF4E50]/12 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 h-96 w-96 rounded-full bg-[#1E4CB8]/18 blur-3xl pointer-events-none" />

      <div className="container-pn relative pt-20 pb-10">
        {/* Top */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="mb-5">
              <Logo to="/" variant="onDark" imgClassName="h-8" testId="footer-logo" />
            </div>
            <p className="text-slate-400 leading-relaxed max-w-sm">
              With +100 combined years in the printing industry, we deliver industry-leading proofing and wide-format solutions.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href={contactInfo.social.instagram} target="_blank" rel="noreferrer"
                 className="h-10 w-10 rounded-full bg-white/5 hover:bg-[#FF4E50] hover:text-white flex items-center justify-center transition-colors">
                <Instagram className="h-4 w-4" />
              </a>
              <a href={contactInfo.social.linkedin} target="_blank" rel="noreferrer"
                 className="h-10 w-10 rounded-full bg-white/5 hover:bg-[#FF4E50] hover:text-white flex items-center justify-center transition-colors">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href={contactInfo.social.facebook} target="_blank" rel="noreferrer"
                 className="h-10 w-10 rounded-full bg-white/5 hover:bg-[#FF4E50] hover:text-white flex items-center justify-center transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
              <a href={contactInfo.social.youtube}
                 className="h-10 w-10 rounded-full bg-white/5 hover:bg-[#FF4E50] hover:text-white flex items-center justify-center transition-colors">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#FF4E50] mb-5">Navigation</h4>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.name}>
                  <Link to={item.href} className="text-slate-300 hover:text-white inline-flex items-center gap-1 group transition-colors">
                    {item.name}
                    <ArrowUpRight className="h-3.5 w-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-5">
            <h4 className="text-sm font-bold uppercase tracking-widest text-[#FF4E50] mb-5">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-slate-300">
                <MapPin className="h-5 w-5 mt-0.5 text-[#FF4E50] flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Phone className="h-5 w-5 text-[#FF4E50] flex-shrink-0" />
                <a href={`tel:${contactInfo.phone.replace(/\D/g, '')}`} className="hover:text-white">{contactInfo.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Mail className="h-5 w-5 text-[#FF4E50] flex-shrink-0" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-white">{contactInfo.email}</a>
              </li>
              <li className="flex items-center gap-3 text-slate-300">
                <Mail className="h-5 w-5 text-[#FF4E50] flex-shrink-0" />
                <a href={`mailto:${contactInfo.support}`} className="hover:text-white">{contactInfo.support}</a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} ProofNation. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-slate-500">
            <a href="#" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Terms of Service</a>
            <a href="#" className="hover:text-white">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
